import React from "react";
import { motion } from "framer-motion";
import {  Col, Button } from "react-bootstrap";
import ReportCard from "../../components/micheal/ReportCard";
import UserBarChart from "../../components/micheal/UserReport/UserBarChart";
import { FiUsers } from "react-icons/fi";              
import { MdVerifiedUser } from "react-icons/md";       
import { HiUserAdd } from "react-icons/hi";            
import { FaUserSlash } from "react-icons/fa";
import EmployeeTable from "../../components/micheal/EmployeeReport/EmployeeTableReport";


function EmployeeReport() {
  const stats = [
    {
      title: "Total Employee",
      value: 600,
      progress: 60,
      icon: FiUsers,
      color: "#28a745",
    },
    {
      title: "Active Employee",
      value: 750,
      progress: 40,
      icon:MdVerifiedUser,
      color: "#ffc107",
    },
    {
      title: "New Employee",
      value: 100,
      progress: 50,
      icon: HiUserAdd,
      color: "#dc3545",
    },
    {
      title: "Inactive Employee ",
      value: 50,
      progress: 45,
      icon: FaUserSlash,
      color: "#0d6efd",
    },
  ];

  const data = [
  { month: "Jan", active: 30, inactive: 10 },
  { month: "Feb", active: 50, inactive: 20 },
  { month: "Mar", active: 60, inactive: 15 },
  { month: "Apr", active: 15, inactive: 5 },
  { month: "May", active: 40, inactive: 10 },
  { month: "Jun", active: 75, inactive: 20 },
  { month: "Jul", active: 30, inactive: 8 },
  { month: "Aug", active: 5, inactive: 2 },
  { month: "Sep", active: 65, inactive: 18 },
  { month: "Oct", active: 40, inactive: 12 },
  { month: "Nov", active: 55, inactive: 15 },
  { month: "Dec", active: 45, inactive: 10 },
];


  const employeeData = [
  {
    id: "Emp-001",
    name: "Antony Lewis",
    role: "Web Designer",
    email: "antony@example.com",
    department: "Finance",
    phone: "1234567890",
    joiningDate: "14 Jan 2024",
    status: "Active",
    avatar: "https://i.pravatar.cc/40?img=1",
  },
  {
    id: "Emp-002",
    name: "Antony Lewis",
    role: "UI/UX Designer",
    email: "antony@example.com",
    department: "Design",
    phone: "9876543210",
    joiningDate: "10 Feb 2024",
    status: "Inactive",
    avatar: "https://i.pravatar.cc/40?img=2",
  },
  {
    id: "Emp-003",
    name: "Antony Lewis",
    role: "Frontend Developer",
    email: "antony@example.com",
    department: "Development",
    phone: "9123456780",
    joiningDate: "05 Mar 2024",
    status: "Active",
    avatar: "https://i.pravatar.cc/40?img=3",
  },
  {
    id: "Emp-004",
    name: "Antony Lewis",
    role: "Backend Developer",
    email: "antony@example.com",
    department: "Development",
    phone: "9988776655",
    joiningDate: "20 Jan 2024",
    status: "Active",
    avatar: "https://i.pravatar.cc/40?img=4",
  },
  {
    id: "Emp-005",
    name: "Antony Lewis",
    role: "HR Manager",
    email: "antony@example.com",
    department: "HR",
    phone: "8899776655",
    joiningDate: "12 Apr 2024",
    status: "Inactive",
    avatar: "https://i.pravatar.cc/40?img=5",
  },
  {
    id: "Emp-006",
    name: "Antony Lewis",
    role: "Project Manager",
    email: "antony@example.com",
    department: "Management",
    phone: "7766554433",
    joiningDate: "30 May 2024",
    status: "Active",
    avatar: "https://i.pravatar.cc/40?img=6",
  },
];


  return (
    <div className="container-fluid mt-3">

      {/* HEADER */}
      <div className="d-flex mb-3">
        <h4 className="mb-0">Employee Report</h4>

        <Button className="ms-auto" variant="dark" size="sm">
          Export
        </Button>
      </div>

      {/* CARDS + CHART */}
      <motion.div className="row mb-3">
        <Col md={6}>
          <ReportCard stats={stats} />
        </Col>

        <Col md={6}>
          <UserBarChart data={data} />
        </Col>
      </motion.div>

      {/* TABLE */}
      <EmployeeTable data={employeeData} />
    </div>
  );
}

export default EmployeeReport;